<template>
  <div class="flex h-full">
    <el-card class="w-300px flex-shrink-0 mr-10px h-full" :body-style="{ height: '100%' }">
      <TitleBorder title="设备厂商">
        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="iconfont icon-bg-more11 text-14px font-bold"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
            <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </TitleBorder>

      <div class="flex mb-10px">
        <el-input
          placeholder="搜索关键字"
          prefix-icon="el-icon-search"
          v-model="treeKeyword"
          class="mr-10px flex-1"
          clearable
          @keyup.enter.native="searchTreeData"
        ></el-input>
        <el-button type="primary" size="mini" class="!h-36px" @click="searchTreeData"
          >搜索</el-button
        >
      </div>

      <div v-loading="treeLoading" class="overflow-y-auto h-[calc(100%-80px)]">
        <el-tree
          v-if="treeStandBy"
          node-key="id"
          ref="treeRef"
          :default-expand-all="defaultExpandAll"
          highlight-current
          :data="treeData"
          :filter-node-method="filterTreeNode"
          :props="defaultTreeProps"
          :default-expanded-keys="defaultExpandedKeys"
          @node-click="handleNodeClick"
        >
          <div slot-scope="{ node }" class="node-item">
            <div class="custom-tree-node">
              <p :title="node.label" class="truncate">
                {{ node.label }}
              </p>
            </div>
          </div>
        </el-tree>
      </div>
    </el-card>
    <el-card class="flex-1 h-full" :body-style="{ height: '100%' }">
      <div ref="formHeightRef">
        <el-form :inline="true" :model="form" ref="form" @submit.native.prevent="search">
          <el-form-item label="" prop="keyWord">
            <el-input v-model="form.keyWord" placeholder="设备编码或名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :disabled="Object.keys(editInfo).length === 0"
              native-type="submit"
              >搜索</el-button
            >
            <el-button @click="reset">重置</el-button>
            <el-button
              type="primary"
              :disabled="!$hasAccess('create') || Object.keys(editInfo).length === 0"
              @click="addHandle"
              >新增</el-button
            >
            <el-button
              type="primary"
              :disabled="!$hasAccess('create') || Object.keys(editInfo).length === 0"
              @click="findDevice"
              >发现设备</el-button
            >
            <el-button
              type="danger"
              :disabled="!selectionList.length"
              @click="delHandle()"
              >删除</el-button
            >
            <!-- <el-button>导入</el-button>
            <el-button>导出</el-button> -->
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="tableData"
        border
        stripe
        :height="`calc(100vh - 200px - ${formHeight}px)`"
        @selection-change="selectionChange"
        v-loading="tableLoading"
        ref="tableRef"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="设备编码" prop="code"></el-table-column>
        <el-table-column label="设备名称" prop="name"></el-table-column>
        <template v-for="(item, index) in tableColumn">
          <el-table-column v-if="item.showList" :key="index" :label="item.label" :prop="item.prop">
            <template slot-scope="{ row }">
              <div v-if="item.fieldType === 'bool'">
                {{ row[item.prop] === 'true' ? '是' : '否' }}
              </div>
              <div v-else>
                {{ row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <el-button size="mini" :disabled="!$hasAccess('update')" @click.stop="editHandle(row)"
              >编辑</el-button
            >
            <el-button size="mini" :disabled="!$hasAccess('delete')" @click.stop="delHandle(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20px"
        background
        @size-change="formTable(editInfo)"
        @current-change="formTable(editInfo)"
        :current-page.sync="initPagination.pageNum"
        :page-size.sync="initPagination.pageSize"
        :total="initPagination.total"
        layout="->,total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
      >
      </el-pagination>

      <EditDialog
        v-if="editDialogShow"
        :show.sync="editDialogShow"
        :type="editType"
        :editTitleInfo="editInfo"
        :editBodyInfo="tableColumn"
        :detailRow="detailRow"
        @reload="editReload"
      ></EditDialog>

      <FindDevice
        v-if="deviceListShow"
        :show.sync="deviceListShow"
        :detailRow="editInfo"
        @reload="formTable(editInfo)"
      ></FindDevice>
    </el-card>
  </div>
</template>

<script>
import { IOTDeviceApi, IOTDeviceTemplateApi } from '@wiz-api/iot-device-management'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import tableHeightMixin from '@/mixins/tableHeightMixin'
import TitleBorder from '@/components/TitleBorder'
import EditDialog from './EditDialog'
import FindDevice from './FindDevice'

const iOTDeviceApi = new IOTDeviceApi()
const dataCategoryApi = new DataCategoryApi()
const ioTdeviceManagementApi = new IOTDeviceTemplateApi()

export default {
  name: 'monitorLinkin',
  mixins: [tableHeightMixin],
  components: {
    EditDialog,
    TitleBorder,
    FindDevice,
  },
  props: {
    // 是否隐藏关键字内容
    isHideKeyword: {
      type: Boolean,
      default: false,
    },
    // HideKeyWord的具体值
    hideKeyword: {
      type: String,
      default: '',
    },
    // 设备类型编码
    deviceTypeCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      treeKeyword: '',
      treeLoading: false,
      treeStandBy: true, // 是否显目录树 用于刷新树
      defaultExpandAll: false,
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      defaultExpandedKeys: [], // 默认展开的id list
      treeData: [],
      form: {
        keyWord: '',
      },
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableColumn: [],
      tableLoading: false,
      selectionList: [],
      editDialogShow: false,
      editType: 'add',
      detailRow: {},
      editInfo: {},
      exportLoading: false,
      deviceListShow: false,
      tableTid: {},
    }
  },
  methods: {
    operateTree(bool) {
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    searchTreeData() {
      this.$refs.treeRef.filter(this.treeKeyword)
    },
    filterTreeNode(value, data) {
      if (!value) {
        return true
      }
      return data.name.indexOf(value) !== -1
    },
    formatDate(cellValue) {
      if (cellValue) return dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
      return cellValue
    },
    selectionChange(val) {
      this.selectionList = val
    },
    addHandle() {
      this.editType = 'add'
      this.editDialogShow = true
    },
    editHandle(row) {
      this.editType = 'edit'
      this.detailRow = row
      this.editDialogShow = true
    },
    async delHandle(row) {
      const ids = row ? [row.id] : this.selectionList.map((item) => { return item.id })
      this.$confirm('是否删除选中的数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err] = await iOTDeviceApi.deleteMany({
          ids
        })
        if (!err) {
          this.$message.success('删除成功')
          await this.formTable(this.editInfo)
        }
      })
    },
    async search() {
      this.initPagination.pageNum = 1
      await this.formTable(this.tableTid)
    },
    async editReload() {
      await this.formTable(this.editInfo)
    },
    async reset() {
      this.$refs.form.resetFields()
      if (!(Object.keys(this.editInfo).length === 0)) {
        this.search()
      }
    },
    // 点击左侧设备树模板
    async handleNodeClick(data) {
      if (data.protocolTypeCode && !data.children) {
        await this.formTitle(data)
        this.initPagination.pageNum = 1
        await this.formTable(data)
        this.editInfo = data
      }
    },
    // 动态title
    async formTitle(data) {
      // 动态表头
      const [err, res] = await ioTdeviceManagementApi.getIOTDeviceTemplateFields({ tid: data.id })
      if (!err) {
        const column = []
        res.templateFields.forEach((item) => {
          item.label = item.fieldTitle
          item.prop = item.fieldName
          column.push(item)
        })
        this.tableColumn = column
      }
    },
    // 表身
    async formTable(data) {
      this.tableLoading = true
      const params = {
        tid: data?.id || '',
        keyWord: this.form.keyWord,
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      }
      if (this.isHideKeyword && this.hideKeyword) {
        params.hideKeyWord = this.hideKeyword
      }
      // table本身
      const [err, res] = await iOTDeviceApi.getIOTDevicesByTemplate(params)
      if (!err) {
        this.tableTid = data
        const tableData = []
        res.items.forEach((item) => {
          const obj = {
            ...item,
          }
          item.fieldValues.forEach((fieldItem) => {
            obj[fieldItem.fieldName] = fieldItem.fieldValue
          })
          tableData.push(obj)
        })
        this.initPagination.total = res.totalCount
        this.tableData = tableData
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout()
        })
      }
      this.tableLoading = false
    },
    async getDeviceList() {
      const listPayload = {
        deviceTypeCode: this.deviceTypeCode,
        maxResultCount: 999,
      }
      const [err, res] = await ioTdeviceManagementApi.getList(listPayload)
      if (!err) {
        const deviceList = Object.values(
          res.items.reduce((acc, item) => {
            const name = item.name
            acc[name] = acc[name] || []
            acc[name].push(item)
            return acc
          }, {})
        )
        const [CategorieRrr, CategorieRes] = await dataCategoryApi.getListByCodes({
          codes: ['IOTDeviceTemplateManufacturer'],
          includeDetails: true,
        })
        if (!CategorieRrr) {
          const treeRes = []
          // init tree data
          CategorieRes.length &&
            CategorieRes[0].dataItems.forEach((item, index) => {
              // form tree children
              let children = []
              deviceList.forEach((deviceItem) => {
                if (item.code === deviceItem[0].manufacturer) {
                  // children = deviceItem
                  children = [...children, deviceItem[0]]
                }
              })
              if (children.length) {
                treeRes.push({
                  name: item.displayName,
                  id: index,
                  code: item.code,
                  children,
                })
              }
            })
          this.treeData = treeRes
        }
      }
    },
    // 发现设备
    findDevice() {
      this.deviceListShow = true
    },
  },
  async created() {
    await this.getDeviceList()
    // 默认展开并点击第一个
    if (this.treeData.length && this.treeData[0].children && this.treeData[0].children.length) {
      const tree = this.$refs.treeRef
      // 展开
      this.defaultExpandedKeys.push(this.treeData[0].id)
      // click
      const firstNodeKey = tree.getNodeKey(tree.store.root.childNodes[0].childNodes[0])
      tree.setCurrentKey(firstNodeKey)
      await this.handleNodeClick(this.treeData[0].children[0])
    }
  },
  mounted() {},
}
</script>

<style lang="scss" scoped></style>
